<template>
  <div class="container">
    <el-row>
      <el-col :span="18">
        <div class="form-container">
          <el-form class="form" ref="form" :model="form" label-width="270px">
            <el-row>
              <el-col :span="18">
                  <div class="head alignRight">ทำการจอง</div>
              </el-col>
              <el-col :span="6">
                  <el-button
                      v-if="type == 'edit'"
                      type="primary"
                      @click="deleteButtonClick"
                      plain="plain"
                      icon="el-icon-delete"
                      class="secondary-button"
                      style="display: flex;"
                  >
                    ลบ
                  </el-button>
              </el-col>
            </el-row>
            <el-row>
              <div class="head subhead alignRight">
                บริการที่ต้องการ
              </div>
            </el-row>
            <el-row>
              <div
                  style="margin-top: 18px;"
                  class="head subhead alignRight"
              >
                รูปแบบงาน
              </div>
            </el-row>
            <el-form-item>
              <span slot="label">
                <i class="el-icon-mobile-phone"></i>
                <span class="require-star">*</span>
                <span class="label">รูปแบบงาน</span>
              </span>
              <el-radio-group
                  :disabled="this.type === 'edit'"
                  class="group-vertical radio"
                  v-model="form.service"
                  @change="prepareCreateReservation"
              >
                <el-radio label="caregiver" style="margin-bottom: 12px;">ดูแลคนไข้</el-radio>
                <el-radio label="escort">พาไปหาหมอ</el-radio>
              </el-radio-group>
            </el-form-item>
            <hr class="form">
            <el-row>
              <div class="head subhead alignRight">สถานที่</div>
            </el-row>
            <el-form-item style="margin-bottom: 0;">
              <span slot="label">
                <i class="el-icon-mobile-phone"></i>
                <span class="require-star">*</span>
                <span class="label">สถานที่ดูแล</span>
              </span>
              <el-checkbox-group class="group-vertical" v-model="locations">
                <el-checkbox label="home">บ้าน</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item style="margin-top: 22px;" v-if="showForm('home')">
              <span slot="label">
                <i class="el-icon-mobile-phone"></i>
                <span class="require-star">*</span>
                <span class="label" slot="label">จังหวัด</span>
              </span>
              <el-select v-model="form.address.province" placeholder="เลือกจังหวัด" @change="changeProvince">
                <el-option v-for="province in provinces" :key="province.value" :label="province.label" :value="province.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="showForm('home')">
              <span slot="label">
                <span class="require-star">*</span>
                <span class="label" slot="label">เขต/อำเภอ</span>
              </span>
              <el-select v-model="form.address.district" placeholder="เลือกเขต/อำเภอ" @change="changeDistrict" :disabled="!form.address.province">
                <el-option v-for="district in districts" :key="district.value" :label="district.label" :value="district.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="showForm('home')">
              <span slot="label">
                <span class="require-star">*</span>
                <span class="label" slot="label">แขวง/ตำบล</span>
              </span>
              <el-select v-model="form.address.subdistrict" placeholder="เลือกแขวง/ตำบล" :disabled="!form.address.district">
                <el-option v-for="subdistrict in subdistricts" :key="subdistrict.value" :label="subdistrict.label" :value="subdistrict.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="showForm('home')">
              <span slot="label">
                <span class="require-star">*</span>
                <span class="label" slot="label">ที่อยู่</span>
              </span>
              <el-input v-model="form.address.address"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom: 22px;" v-if="showForm('home')">
              <span slot="label">
                <i class="el-icon-mobile-phone"></i>
                <span class="label">จุดสังเกตใกล้บ้าน</span>
              </span>
              <el-input v-model="form.address.landmark"></el-input>
            </el-form-item>
            <el-form-item v-if="showForm('home')">
              <span slot="label">
                <span class="label" slot="label">ปักหมุดที่อยู่</span>
              </span>
              <el-input v-model="form.addressLatLng" placeholder="ละติจูด, ลองจิจูด"></el-input>
            </el-form-item>
            <el-form-item style="margin-top: 8px;">
              <span slot="label">
                <span class="label"></span>
              </span>
              <el-checkbox-group class="group-vertical" v-model="locations">
                <el-checkbox label="hospital">โรงพยาบาล</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item v-if="showForm('hospital')">
              <span slot="label">
                <i class="el-icon-mobile-phone"></i>
                <span class="require-star">*</span>
                <span class="label" slot="label">จังหวัด</span>
              </span>
              <el-select v-model="form.hospital.province" placeholder="เลือกจังหวัด" @change="changeProvinceHospital">
                <el-option v-for="province in provinces" :key="province.value" :label="province.label" :value="province.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="showForm('hospital')">
              <span slot="label">
                <i class="el-icon-mobile-phone"></i>
                <span class="require-star">*</span>
                <span class="label" slot="label">ชื่อโรงพยาบาล</span>
              </span>
              <el-autocomplete class="hospital auto-complete-hospital" :disabled="!form.hospital.province"
                v-model="form.hospital.name" placeholder="เลือกโรงพยาบาล" :fetch-suggestions="queryHospital" @select="handleAutocompleteHospital" suffix-icon="el-icon-search"></el-autocomplete>
            </el-form-item>
            <el-form-item v-if="showForm('hospital')">
              <span slot="label">
                <span class="require-star">*</span>
                <span class="label" slot="label">ห้อง/ชั้น/ตึก</span>
              </span>
              <el-input v-model="form.hospital.room"></el-input>
            </el-form-item>
            <el-form-item v-if="showForm('hospital')">
              <span slot="label">
                <i class="el-icon-mobile-phone"></i>
                <span class="label">จุดสังเกตใกล้โรงพยาบาล</span>
              </span>
              <el-input v-model="form.hospital.landmark"></el-input>
            </el-form-item>
            <el-form-item v-if="showForm('hospital')">
              <span slot="label">
                <span class="label" slot="label">ปักหมุดที่อยู่</span>
              </span>
              <el-input v-model="form.hospitalLatLng" placeholder="ละติจูด, ลองจิจูด"></el-input>
            </el-form-item>
            <hr class="form">
            <el-form-item style="margin-bottom: 88px;">
              <span class="label" slot="label">เรื่องอื่นๆ</span>
              <p v-if="form.patientNote" style="font-size: 18px; color: #A2A7B3; margin-bottom: 8px;">
                ลูกค้า : {{ form.patientNote }}
              </p>
              <p style="font-size: 18px; color: #A2A7B3; margin-bottom: 8px;">
                <i class="el-icon-mobile-phone"></i>
                <span>แอดมิน : </span>
              </p>
              <el-input type="textarea" :rows="3" v-model="form.caregiverNote" placeholder="เช่น  สิ่งที่คนไข้ชอบ หรือ ไม่ชอบให้ทํา"></el-input>
            </el-form-item>
            <div v-if="form.service !== 'escort'">
              <el-form-item v-if="showForm('hospital') &amp;&amp; !showForm('home')" style="margin-bottom:73px;">
                <span slot="label">
                  <i class="el-icon-mobile-phone"></i>
                  <span class="require-star">*</span>
                  <span class="label" slot="label">ผู้ดูแลต้องทำกิจกรรมการดูแลที่โรงพยาบาลหรือไม่</span>
                </span>
                <el-row>
                  <el-radio-group class="group-vertical radio" v-model="form.hospital.care" @input="getPrice">
                    <el-radio :label="false">ไม่ต้องทำ ผู้ดูแลอยู่เฝ้าคนไข้อย่างเดียวพยาบาลจะเป็นผู้ทำกิจกรรมการดูแล</el-radio>
                    <el-radio :label="true" style="margin-top: 16px;">ต้องทำ เพื่อช่วยพยาบาลในการดูแลคนไข้ เมื่อการดูแลไม่ทั่วถึง</el-radio>
                  </el-radio-group>
                </el-row>
              </el-form-item>
            </div>
            <hr class="form" />
            <el-form-item style="margin-bottom: 45px">
              <span class="label" slot="label">ประเภทพนักงาน</span>
              <el-checkbox-group :disabled="reservation.paid" class="group-vertical" v-model="form.requireCaregiverTypes">
                <el-checkbox label="CG">แคร์โปร ผู้ดูแลมืออาชีพ (CG)</el-checkbox>
                <el-checkbox label="CGN">นักเรียนแคร์โปร ผู้ดูแลมืออาชีพ (CGN)</el-checkbox>
                <el-checkbox label="NA">พนักงานผู้ช่วยพยาบาล (NA)</el-checkbox>
                <el-checkbox label="PN">ผู้ช่วยพยาบาล (PN)</el-checkbox>
                <el-checkbox label="RN">พยาบาล (RN)</el-checkbox>
                <el-checkbox label="DR">แพทย์ (DR)</el-checkbox>
                <el-checkbox label="PT">นักกายภาพบําบัด (PT)</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item style="margin-bottom: 47px">
              <span slot="label">
                <i class="el-icon-mobile-phone"></i>
                <span class="label">ประเภทงาน</span>
              </span>
              <el-row>
                <el-radio-group class="group-vertical radio" v-model="form.workType" @change="handleChangeWorkType" v-if="form.service !== 'escort'">
                  <el-radio label="hr24">อาศัยกับคนไข้
                    <div style="margin-top: 16px; margin-left: 24px;" v-if="form.workType==='hr24'">
                      <span slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        <span class="require-star">*</span>
                        <span class="label" slot="label">เวลา</span>
                      </span>
                      <el-radio-group style="margin-top: 24px;" class="group-vertical radio" v-model="form.shift.type" @change="handleChangeShift">
                        <el-radio label="day">เวรกลางวัน</el-radio>
                        <el-radio label="night" style="margin-top: 22px;">เวรกลางคืน</el-radio>
                      </el-radio-group>
                    </div>
                  </el-radio>
                  <el-radio label="hr12" style="margin-top: 8px;">ไป-กลับ
                    <div style="margin-top: 16px; margin-left: 24px;" v-if="form.workType==='hr12'">
                      <span slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        <span class="require-star">*</span>
                        <span class="label" slot="label">เวลา</span>
                      </span>
                      <el-radio-group style="margin-top: 24px;" class="group-vertical radio" v-model="form.shift.type" @change="handleChangeShift">
                        <div class="group-horizontal timeRange">
                          <el-radio label="day">เวรกลางวัน</el-radio>
                          <div class="time-select-container">
                            <el-time-select v-model="day.start" :picker-options="pickerOptions" @change="form.shift.start = $event"></el-time-select><span style="margin: 0 8px; color: #a8b0b6;">-</span>
                            <el-time-select v-model="day.end" :picker-options="pickerOptions" @change="form.shift.end = $event"></el-time-select>
                          </div>
                        </div>
                        <div class="group-horizontal timeRange">
                          <el-radio label="night">เวรกลางคืน</el-radio>
                          <div class="time-select-container">
                            <el-time-select v-model="night.start" :picker-options="pickerOptions" @change="form.shift.start = $event"></el-time-select><span style="margin: 0 8px; color: #a8b0b6;">-</span>
                            <el-time-select v-model="night.end" :picker-options="pickerOptions" @change="form.shift.end = $event"></el-time-select>
                          </div>
                        </div>
                      </el-radio-group>
                    </div>
                  </el-radio>
                </el-radio-group>
                <div v-else>
                  <span style="font-size: 18px; color: #434B61; margin-bottom: 8px;">ไป-กลับ</span>
                  <div>
                    <span slot="label">
                      <i class="el-icon-mobile-phone"></i>
                      <span class="require-star">*</span>
                      <span class="label" slot="label">เวลา</span>
                    </span>
                    <el-radio-group style="margin-top: 16px;" class="group-vertical radio" v-model="form.shift.type" @change="handleChangeShift">
                      <div class="group-horizontal timeRange">
                        <span style="font-size: 18px; color: #434B61; margin-bottom: 8px;">กลางวัน</span>
                        <div class="time-select-container">
                          <el-time-select
                              v-model="day.start"
                              :picker-options="pickerOptions"
                              @change="
                                form.shift.start = $event
                                day.end = $event ? `${((Number(form.shift.start.split(':')[0]) + 8) % 24).toString().padStart(2, '0')}:${form.shift.start.split(':')[1]}` : ''
                                form.shift.end = day.end
                              "
                          ></el-time-select>
                          <span style="margin: 0 8px; color: #a8b0b6;">-</span>
                          <el-time-select
                              disabled v-model="day.end"
                              :picker-options="pickerOptions"
                          ></el-time-select>
                        </div>
                      </div>
                    </el-radio-group>
                  </div>
                </div>
              </el-row>
            </el-form-item>
            <hr class="form" />
            <el-row>
              <div class="head subhead alignRight">ราคา</div>
            </el-row>
            <el-form-item style="margin-bottom: 12px" v-if="this.type === 'create'">
              <span slot="label">
                <span class="require-star">*</span>
                <span class="label">แพ็กเกจราคา</span>
              </span>
              <span v-if="form.service === 'escort'" style="font-size: 18px; color: #434B61; margin-bottom: 8px;">พาไปหาหมอ:  {{ (pricePlan.daily[0] || 0) | numberFormat }} บาท/เวร</span>
              <el-row v-if="pricePlan.daily.length">
                <el-radio-group class="group-vertical radio" v-model="selectedPackage" @change="onSeleckPckType" style="padding-bottom: 40px" v-if="form.service !== 'escort'" :disabled="!pricePlan.daily[0]">
                  <el-radio label="daily" style="margin-bottom: 8px;">รายวัน : {{ (pricePlan.daily[0] || 0) | numberFormat }} บาท/เวร
                    <div style="margin-top: 16px; margin-left: 24px;" v-if="selectedPackage==='daily'">
                      <el-select class="select-package" placeholder="เลือกจำนวนวัน" v-model.number="selectedPackageLength" @change="handleChangePackage(selectedPackageLength)">
                        <el-option v-for="(package_item, index) in pricePlan.daily" :key="'selectedPackage' + package_item" :label="(index+1) + ' เวร  = ' + $options.filters.numberFormat(package_item)" :value="index +1">
                          <template>
                            <span class="title" :class="{ red: (index + 1) &gt;= pricePlan.overPriced }">{{ index+1 }} เวร&nbsp;</span>
                            <span class="detail" :class="{ red: (index + 1) &gt;= pricePlan.overPriced }">= {{ package_item | numberFormat }}</span>
                          </template>
                        </el-option>
                      </el-select>
                    </div>
                  </el-radio>
                  <el-radio label="monthly">รายเดือน : {{ pricePlan.monthly | numberFormat }} บาท/เดือน
                    <div style="margin-top: 16px; margin-left: 24px;" v-if="selectedPackage==='monthly'">
                      <el-select class="select-package" placeholder="เลือกแพ็กเกจเสริม" v-model="selectedAddonPackage" @change="handleChangePackage(selectedPackageLength)">
                        <el-option label="มีวันหยุด (26 วัน)" value="none">
                          <template>
                            <span class="detail">มีวันหยุด (26 วัน)</span>
                          </template>
                        </el-option>
                        <el-option label="ไม่มีวันหยุด (30 วัน)" value="monthlyWithAddon">
                          <template>
                            <span class="title">ไม่มีวันหยุด (30 วัน)</span>
                          </template>
                        </el-option>
                      </el-select>
                    </div>
                  </el-radio>
                </el-radio-group>
                <el-select class="select-package" placeholder="เลือกจำนวนวัน" v-model.number="selectedPackageLength" @change="handleChangePackage(selectedPackageLength)" disabled v-else>
                  <el-option v-for="(package_item, index) in pricePlan.daily" :key="'selectedPackage' + package_item" :label="(index+1) + ' เวร  = ' + $options.filters.numberFormat(package_item)" :value="index +1">
                    <template>
                      <span class="title" :class="{ red: (index + 1) &gt;= pricePlan.overPriced }">{{ index+1 }} เวร&nbsp;</span>
                      <span class="detail" :class="{ red: (index + 1) &gt;= pricePlan.overPriced }">= {{ package_item | numberFormat }}</span>
                    </template>
                  </el-option>
                </el-select>
              </el-row>
            </el-form-item>
            <el-form-item style="margin-bottom: 22px; width: 900px;" v-if="this.type === 'edit'">
              <span slot="label">
                <span class="require-star">*</span>
                <span class="label">แพ็กเกจ</span>
              </span>
              <div style="display: flex; flex-direction: column;">
                <div v-if="pck === 'daily'" style="display: flex; flex-direction: row; align-items: baseline;"><span class="unit-text" style="width: 400px">รายวัน ({{ dates.length }} เวร)  :</span>
                  <el-input :disabled="reservation.paid" v-model.number="form.price.base" @input="getPrice" type="number" min="0"></el-input><span class="unit-text" style="width:200px">บาท/เวร</span><span class="unit-text" style="color: #A2A7B2;">*ระบุยอดรวมค่าอาหาร</span></div>
                <div v-if="pck === 'monthly'" style="display: flex; flex-direction: row; align-items: baseline;"><span class="unit-text" style="width: 900px">รายเดือน มีวันหยุด (26 วัน) :</span>
                  <el-input :disabled="reservation.paid" v-model.number="form.price.base" @input="getPrice" type="number" min="0"></el-input><span class="unit-text" style="width:fit-content">บาท</span><span class="unit-text" style="color: #A2A7B2;">*ระบุยอดรวมค่าอาหาร</span></div>
                <div v-if="pck === 'monthlyWithAddon'" style="display: flex; flex-direction: row; align-items: baseline; margin-top: 4px"><span class="unit-text" style="width: 900px">รายเดือน ไม่มีวันหยุด (30 วัน) :</span>
                  <el-input :disabled="reservation.paid" v-model.number="form.price.base" @input="getPrice" type="number" min="0"></el-input><span class="unit-text" style="width:fit-content">บาท</span><span class="unit-text" style="color: #A2A7B2;">*ระบุยอดรวมค่าอาหาร</span></div>
              </div>
            </el-form-item>
            <el-form-item style="margin-bottom: 47px; margin-top: 27px;">
              <span class="label" slot="label">ส่วนลด</span>
              <div class="group-horizontal">
                <el-select :disabled="reservation.paid || !selectedPackage" v-model="form.price.discount.type" placeholder="ไม่มี" @change="clearDiscount">
                  <el-option key="no" label="ไม่มี" value="no"></el-option>
                  <el-option key="fixed" label="บาท" value="fixed"></el-option>
                  <el-option key="percent" label="%" value="percent"></el-option>
                  <el-option key="code" label="โค้ด" value="code" v-if="lineIdCheck"></el-option>
                </el-select>
                <el-input class="discount-input" v-if="isHaveNormalDiscount" type="number" v-model.number="form.price.discount.value" @input="getPrice"></el-input><span v-if="form.price.discount.type==='fixed'">บาท</span><span v-if="form.price.discount.type==='percent'">%</span>
                <el-select v-if="form.price.discount.type==='code' &amp;&amp; lineIdCheck &amp;&amp; type === 'create'"
                  v-model="form.promotionCode" placeholder="เลือกโค้ด" @change="getPrice">
                  <el-option v-for="code in codeList" :key="code" :label="code" :value="code"></el-option>
                </el-select>
                <el-button class="discount-button" plain="plain" size="medium" v-if="form.price.discount.type==='code' &amp;&amp; lineIdCheck &amp;&amp; type === 'edit'" @click="changePromo"><span>{{ form.promotionCode }}</span><i class="el-icon-edit"></i></el-button><span v-if="form.price.discount.type==='code' &amp;&amp; lineIdCheck &amp;&amp; type === 'edit'">&nbsp;</span>
              </div>
            </el-form-item>
            <el-form-item style="margin-bottom: 47px;" v-if="this.type === 'edit'">
              <span slot="label">
                <span class="require-star">*</span>
                <span class="label" slot="label">ต่างจังหวัด</span>
              </span>
              <div style="display: flex; flex-direction:row; align-items: center;">
                <el-input :disabled="reservation.paid" v-model.number="form.price.zone" @input="getPrice" type="number" min="0"></el-input>
                <div class="unit-text">บาท</div>
              </div>
            </el-form-item>
            <hr class="form" />
            <el-row>
              <div class="head subhead alignRight">เวร</div>
            </el-row>
            <el-form-item style="margin-bottom: 22px;" v-if="this.type === 'edit'">
              <span slot="label">
                <span class="label" slot="label">จำนวนเวร</span>
              </span>
              <div style="display: flex; flex-direction:row; align-items: center;">
                <div class="unit-text" v-if="pck === 'daily'">{{ dates.length }} เวร</div>
                <div class="unit-text" v-else>1 เดือน</div>
              </div>
            </el-form-item>

            <el-form-item
              v-if="(type === 'edit' && form.price.package === 'monthly') || (type === 'create' && selectedPackage === 'monthly' && selectedAddonPackage === 'none')"
              style="margin-bottom: 47px; margin-top: 27px;">
              <span class="label" slot="label">วันหยุด</span>
              <div class="group-vertical">
                <el-select :disabled="!canEditDaysOff" v-model="dayOff" placeholder="ไม่มี" @change="onDaysOffChange">
                  <el-option key="daysOff-sun" label="วันอาทิตย์" value="Sunday"></el-option>
                  <el-option key="daysOff-mon" label="วันจันทร์" value="Monday"></el-option>
                  <el-option key="daysOff-tue" label="วันอังคาร" value="Tuesday"></el-option>
                  <el-option key="daysOff-wed" label="วันพุธ" value="Wednesday"></el-option>
                  <el-option key="daysOff-thu" label="วันพฤหัสบดี" value="Thursday"></el-option>
                  <el-option key="daysOff-fri" label="วันศุกร์" value="Friday"></el-option>
                  <el-option key="daysOff-sat" label="วันเสาร์" value="Saturday"></el-option>
                </el-select>
                <span v-if="!canEditDaysOff" style="color: #A2A7B2; line-height: 16px; font-size: 12px; margin-top: 8px;">ไม่สามารถแก้ไขวันหยุดสำหรับเคสที่เริ่มงานไปแล้วได้</span>
              </div>
            </el-form-item>

          <!-- Day Time Calendar -->
            <div class="calendar-container" v-show="showCalendar" style="margin-left: 271px;">
              <div class="btn-calendar-container">
                <el-button icon="el-icon-arrow-left" @click="goPreviousMonth" style="margin-top: -8px;"></el-button>
                <el-button icon="el-icon-arrow-right" @click="goNextMonth" style="margin-left: 604px; min-width: 60px; max-width: 60px; margin-top: -8px;"></el-button>
              </div>
              <day-picker-calendar
                id="calendarReservEditDay"
                v-model="form.dates"
                ref="calendar"
                :isAllowAddEvent="form.canEditRequireCaregiverTypes"
                :maxDate="maxDate"
                :daysOff="form.daysOff"
                style="margin-top: 10px;"
                :pck="pck"
                :typeCalendar="calendarType"></day-picker-calendar>
            </div>
          </el-form>
        </div>
      </el-col>
      <el-col class="price-container" :span="6">
        <div class="price-item-container">
          <div class="price-item">
            <div class="price-detail" style="font-weight: 600; color: #303133;">แพ็กเกจ:
              <span v-if="form.service === 'escort'">หาหมอ (1 วัน)</span>
              <span v-else-if="pck === 'monthly'">รายเดือน แบบมีวันหยุด (26 วัน)</span>
              <span v-else-if="pck === 'monthlyWithAddon'">รายเดือน แบบไม่มีวันหยุด (30 วัน)</span>
              <span v-else-if="selectedPackage === 'daily'">รายวัน ({{selectedPackageLength}} เวร)</span>
            </div>
          </div>
          <div class="price-item">
            <div class="price-detail" style="font-weight: 300; color: #303133;">ค่าบริการ<span v-if="pck === 'monthly' || pck === 'monthlyWithAddon'"> ({{ (panelPrice.perDay || 0) | numberFormat }} บาท/วัน)</span><span v-else-if="selectedPackage === 'daily'"> ({{ panelPrice.perDay | numberFormat }} บาท/วัน)</span></div>
            <div class="price-detail" style="font-weight: 300; color: #303133;">{{ panelPrice.base | numberFormatTwoDigit }} บาท</div>
          </div>
          <div class="price-item">
            <div class="price-detail" style="font-weight: 300; color: #303133;">ค่าอาหาร<span v-if="pck !== ''"> (150 บาท/วัน)</span></div>
            <div class="price-detail" style="font-weight: 300; color: #303133;">{{ panelPrice.meal | numberFormatTwoDigit }} บาท</div>
          </div>
          <div class="price-item">
            <div class="price-detail" v-if="form.price.discount.type==='no'" style="font-weight: 300; color: #303133;">ส่วนลด</div>
            <div class="price-detail" v-else-if="form.price.discount.type==='percent'" style="font-weight: 300; color: #303133;">ส่วนลด ({{ form.price.discount.value }}%)</div>
            <div class="price-detail" v-else-if="form.price.discount.type==='fixed'" style="font-weight: 300; color: #303133;">ส่วนลด ({{ form.price.discount.value }}บาท)</div>
            <div class="price-detail" v-else-if="form.price.discount.type==='code' &amp;&amp; lineIdCheck" style="font-weight: 300; color: #303133;">ส่วนลด ({{ form.promotionCode }})</div>
            <div class="price-detail" v-else style="font-weight: 300; color: #303133;">ส่วนลด</div>
            <div class="price-detail" style="font-weight: 300; color: #303133;">- {{ calculator.valueDiscount() | numberFormatTwoDigit }} บาท</div>
          </div>
          <div class="price-item">
            <div class="price-detail" style="font-weight: 300; color: #303133;">ต่างจังหวัด</div>
            <div class="price-detail" style="font-weight: 300; color: #303133;">{{ panelPrice.zone | numberFormatTwoDigit }} บาท</div>
          </div>
          <div class="price-item">
            <div class="price-detail" style="font-weight: 300; color: #303133;">VAT 7%</div>
            <div class="price-detail" style="font-weight: 300; color: #303133;">{{ panelPrice.vat | numberFormatTwoDigit }} บาท</div>
          </div>
          <div class="price-item" v-show="reservation.customerType === 'company'">
            <div class="price-detail" style="font-weight: 300; color: #303133;">ภาษีหัก ณ ที่จ่าย</div>
            <div class="price-detail" style="font-weight: 300; color: #303133;">- {{ panelPrice.tax | numberFormatTwoDigit }} บาท</div>
          </div>
          <hr class="price summarize" />
          <div class="price-item" style="margin-top: 3px;">
            <div class="price-detail price-summarize">ราคารวม</div>
            <div class="price-detail price-summarize">{{ calculator.netPrice() | numberFormatTwoDigit }} บาท</div>
          </div>
        </div>
        <div class="fixedFloatBar">
          <el-button plain="plain" @click="clickCancel" class="cancel-button">ยกเลิก</el-button>
          <el-button type="primary" @click="confirmUpdateStartDateVaildate" :disabled="isDisabledSave">
            <div v-if="type === 'create'">จอง</div>
            <div v-else>อัพเดต</div>
          </el-button>
        </div>
      </el-col>

      <!-- Promotion Code Dialog -->
      <el-dialog :visible.sync="edit.showDialog" width="30%" :before-close="handleClose" :show-close="false" center="center">
        <el-select v-model="edit.modalPromotionCode" placeholder="เลือกโค้ด" style="margin: 30px 0 40px 0;">
          <el-option v-for="code in codeList" :key="code" :label="code" :value="code"></el-option>
        </el-select>
        <span class="dialog-footer" style="justify-content: center;" slot="footer">
          <el-button @click="handleClose" class="secondary-button">ยกเลิก</el-button>
          <el-button type="primary" @click="handleUpdate">อัพเดต</el-button>
        </span>
      </el-dialog>

      <!-- Is Fake Dialog -->
      <el-dialog :visible.sync="controlFakeDialog" :showClose="false"
        :closeOnClickModal="false" style="margin-top: 19vh;" width="30%">
        <div style="display: flex; align-items: flex-start; margin-top: 30px; flex-direction: column;">
          <div class="dialog-header-18" style="margin-bottom: 4px;">ทำการจอง</div>
          <el-radio-group class="group-vertical radio" v-model="form.fake">
            <el-radio :label="false" style="margin-bottom: 8px;">Reservation จริง</el-radio>
            <el-radio :label="true">Reservation ปลอม</el-radio>
          </el-radio-group>
        </div>
        <span class="dialog-footer" slot="footer">
          <el-button class="edit" type="primary" @click="closeFakeDialog()">ยืนยัน</el-button>
        </span>
      </el-dialog>

      <!-- Update Start Date Next Reservation To Today Confirmation Dialog -->
      <el-dialog id="paid" :visible.sync="showUpdateStartDateReservationToTodayConfirmationDialog" :closeOnClickModal="false" style="margin-top: 19vh;" :showClose="false" width="30%">
        <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;">
          <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" style="align-self: flex-start;" />
          <div class="header-18" style="margin-left: 17px;">ยืนยันให้ระบบจะทําการตัดบัตรลูกค้าตอนนี้</div>
        </div>
        <span class="dialog-footer" slot="footer">
          <el-button class="cancel-button" @click="showUpdateStartDateReservationToTodayConfirmationDialog = false">ไม่</el-button>
          <el-button type="primary" @click="clickSave" class="edit">ยืนยัน</el-button>
        </span>
      </el-dialog>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
  $float-bar: 1000;

  @media (max-width: 1360px) {
    .form-container {
      margin-left: -70px;
    }
  }

  hr.form {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #dcdfe6;
    margin-bottom: 53px;
    padding: 0;
  }

  hr.price {
    border: solid 1px #e4e7ed;
    margin-bottom: 21px;
    margin-top: 3px;

    &.summarize {
      border: solid 0.5px #434B61;
    }
  }

  .el-button--primary.is-plain {
    background: #FFF;
    border: 2px solid #409EFF;

    &:hover {
      background: #409EFF;
    }

    &:active {
      color: #409EFF;
    }

    &:focus {
      color: #409EFF;

      &:hover {
        color: #FFFFFF;
      }
    }
  }

  .el-icon-delete {
    font-weight: 800;
  }

  .price-container {
    height: calc(100vh - 60px);
    position: fixed;
    z-index:900;
    top:60px;
    right:0;
    box-shadow: 2px 3px 15px 2px #dcdfe6;
    background: #FFF;
  }

  .price-item-container {
    padding: 41px 27.5px 0 28.5px;
  }

  .price-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 18px;
    padding-left: 14px;
    padding-right: 7px;
  }

  .price-detail {
    font-family: "Sukhumvit";
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.25;
    letter-spacing: normal;
    color: #c0c4cc;
  }

  .price-black {
    font-weight: 600;
    color: #606266;
  }

  .price-summarize {
    font-family: "Sukhumvit-Bold";
    font-weight: bold;
    font-size: 20px;
    color: #303133;
  }

  .container {
    padding-top: 163px;
    padding-bottom: 100px;
  }

  .fixedFloatBar {
    width: 25%;
    position: fixed;
    bottom: 27px;
    background-color: white;
    padding: 10px;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .head {
    font-family: "Sukhumvit-Bold";
    font-weight: 600;
    font-size: 36px;
    text-align: right;
    width: 260px;
    margin-bottom: 40px;
  }

  .subhead {
    font-size: 22px;
    margin-bottom: 30px;
  }

  i {
    margin-right: 5px;
    color: #dcdfe6;
    font-size: 20px;
  }

  .alignRight {
    text-align: right;
  }

  span.label {
    font-family: "Sukhumvit-Bold";
    color: black;
    font-size: 18px;
    font-weight: 600;
  }

  .el-form-item {
    margin-top: -10px;
    width: 600px;
  }

  .group-horizontal {
    width: 500px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    &.area {
      width: 400px;
      height: 50px;
    }
    &.timeRange {
      width: 560px;
      margin-bottom: 20px;
    }
    &.price {
      width: 270px;
      height: 50px;
    }
  }

  .group-vertical {
    width: 500px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .calendar-container {
    margin-top: 10px;
    margin-bottom: 100px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 950px;
  }

  .btn-calendar-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: absolute;
  }

  .full-calendar-container {
    width: 750px;
    height: 400px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .el-checkbox+.el-checkbox {
    margin-left: 0px;
  }

  .el-radio+.el-radio {
    margin-left: 0px;
    margin-top: 5px;
  }

  .el-input {
    margin-top: -10px;
    /* width: */
  }

  .el-range-editor {
    margin-top: -10px;
  }

  .el-textarea {
    width: 500px;
  }

  .input-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 800px;
    margin-top: 10px;
  }

  .time-select-container {
    width: 460px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .short {
    max-width: 220px;
  }

  .input-trailing-text {
    margin-left: 10px;
    margin-top: -10px;
  }

  .priceHeader {
    font-size: 18px;
    color: #c0c4cc;
    font-weight: 600;
  }

  .content {
    font-size: 18px;
    color: #c0c4cc;
    width: 400px;
  }

  .group-vertical {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    &.radio {
      margin-top: 12px;
      margin-left: 0px;
      font-size: 16px;
    }

    .el-date-editor.el-input {
      width: 100px;
    }

    .time-select-container[data-v-316db426] {
      justify-content: flex-start;
    }
  }

  .el-radio.selectedPackageLength {
    margin-bottom: 18px;
  }

  .unit-text {
     font-size: 18px;
     margin-left: 10px;
     color: #606266;
     width: 100%;
  }

  .require-star {
    font-family: 'Sukhumvit';
    font-size: 18px;
    font-weight: normal;
    color: #C0C4CC;
    margin-right: 4px;
  }

  .discount-input {
    width: 125px;
    margin-top: 0;
    margin-left: -30px;
  }

  .discount-button {
    span {
      font-size: 14px;
      font-family: 'Sukhumvit-Medium';
      font-weight: 200;
      margin-right: 25px;
    }
  }

  .el-button--medium {
    padding: 2px 20px;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
  }

  .dialog-header-18 {
    font-weight: 700;
    font-size: 18px;
    line-height: 29px;
    color: #434B61;
    font-family: 'Sukhumvit-Bold';
  }

  .header-18 {
    font-weight: 500;
    font-size: 18px;
    line-height: 29px;
    color: #434B61;
  }

  .default-package {
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    width: 243.6px;
    padding: 0 15px;
    margin-bottom: 4px;
    background-color: white;

    &:hover {
      background-color: #E4E7ED;
      cursor: pointer;
    }
  }

  span {
    &.title {
      color: #606266;
      font-weight: bold;
      margin-right: 8px;
      font-size: 18px;
      -webkit-text-stroke-width: 0.1px;
      -webkit-text-stroke-color: #606266;

        &.red {
          color: #FF577F;
        }
    }

    &.detail {
      color: #606266;
      font-weight: 300;
      font-size: 18px;

      &.red {
        color: #FF577F;
      }
    }
  }

  .day-left {
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    color: #A2A7B3;
    margin-top: -21px;
    margin-bottom: 30px;
  }
</style>

<style lang="scss">
  .fc-head-container .fc-widget-header {
    border: 0;
  }

  .fc-widget-content {
    background-color: #fff;
  }

  .el-dialog__body {
    display: flex;
    flex-direction: column;
  }

  .el-dialog {
    border-radius: 8px;
  }

  .el-select-dropdown__item.is-disabled {
    opacity: 0.25;
  }

  .select-package {
    .el-input__inner {
      font-size: 18px;
      font-weight: 300;
      -webkit-text-stroke-width: 0.1px;
      -webkit-text-stroke-color: #606266;
      color: #606266;

      &::placeholder {
        color: #606266;
        -webkit-text-stroke-width: 0px;
        font-weight: 400;
      }
    }
  }
</style>

<script>
import { ReservationModel, ReservationPricing, ReservationDefaultPricing } from '@/model/ReservationModel'
import DayPickerCalendar from '@/components/shared/DayPickerCalendar'
import { GenericAPIHandler } from '@/components/shared/GenericAPIHandler'

export default {
  name: 'ReservationForm',
  components: {
    DayPickerCalendar,
  },
  mixins: [GenericAPIHandler],
  mounted () {
    this.getProvinces()
  },
  data () {
    return {
      selectedPackageLength: 31,
      selectedAddonPackage: 'none',
      selectedPackage: null,
      packages: [],
      recommendedPackages: [],
      canEditDaysOff: true,
      panelPrice: {
        base: 0,
        meal: 0,
        beforeDiscount: 0,
        afterDiscount: 0,
        discount: 0,
        shifts: 0,
        shiftsTotal: 0,
        zone: 0,
        total: 0,
        vat: 0,
        tax: 0,
        net: 0,
        perDay: 0,
        pricePlan: {
          daily: 0,
          monthly: 0,
          monthlyPerDay: 0,
          monthlyWithAddonPerDay: 0,
        },
      },
      priceCalculator: new ReservationDefaultPricing(),
      form: new ReservationModel(),
      allowDates: [],
      rawHospital: [],
      provinces: [],
      districts: [],
      subdistricts: [],
      locations: [],
      day: {
        start: '07:00',
        end: '19:00',
      },
      night: {
        start: '19:00',
        end: '07:00',
      },
      pickerOptions: {
        start: '00:00',
        step: '00:30',
        end: '24:00',
      },
      dates: ['2018-08-26T00:00:00Z', '2018-08-27T00:00:00Z'],
      patientId: 0,
      customerType: '',
      price: {},
      codeList: [],
      edit: {
        showDialog: false,
        modalPromotionCode: '', // value in dropdown on modal
        beforePromotionCode: '', // value from prepareupdate
        tempPromotionCode: '', // save for check change promotion code
        discount: {
          type: '',
          value: 0,
        },
      },
      pricePlan: {
        daily: [],
        monthly: 0,
      },
      showIsFakeDialog: true,
      dayOff: 'Sunday',
      showUpdateStartDateReservationToTodayConfirmationDialog: false,
    }
  },
  watch: {
    locations (val, oldVal) {
      if (!val.includes('home') || (val.includes('home') && !oldVal.includes('home'))) {
        this.form.address = {
          address: '',
          province: '',
          district: '',
          subdistrict: '',
          landmark: '',
          latLng: '',
        }
      }
      if (!val.includes('hospital') || (val.includes('hospital') && !oldVal.includes('hospital'))) {
        this.form.hospital = {
          name: '',
          province: '',
          room: '',
          landmark: '',
          latLng: '',
          care: false,
        }
      }
      this.getPrice()
    },
    reservation (val) {
      if (this.type === 'edit') {
        this.canEditDaysOff = false
        this.edit.tempPromotionCode = val.promotionCode
        this.form = val
        this.customerType = val.customerType
        this.selectedPackageLength = this.form.dates.length
        this.selectedPackage = val.price.package
        this.allowDates = this.form.dates
        this.dates = this.form.dates
        this.dayOff = this.form.daysOff[0]
        this.forceUpdateCalendar(this.form.dates)
        if (val.shift.type === 'day') {
          this.day.start = val.shift.start
          this.day.end = val.shift.end
        } else {
          this.night.start = val.shift.start
          this.night.end = val.shift.end
        }
        if (val.promotionCode !== '') {
          this.edit.discount.type = val.price.discount.type
          this.edit.discount.value = val.price.discount.value
          this.form.price.discount.type = 'code'
          this.form.price.discount.value = 1
        } else if (val.price.discount.type === '') {
          this.form.price.discount.type = 'no'
          this.form.price.discount.value = 1
        }
        this.edit.beforePromotionCode = val.promotionCode
        if (this.form.hospital) {
          this.locations.push('hospital')
          this.getRawHospital()
        } else {
          this.form.hospital = new ReservationModel().hospital
        }
        if (this.form.address) {
          this.locations.push('home')
          this.getDistricts()
          this.getSubdistricts()
        } else {
          this.form.address = new ReservationModel().address
        }
        this.patientId = val.patientId
        this.updateStrategy()
      } else {
        this.canEditDaysOff = true
        this.recommendedPackages = val.recommendedPackages
        this.selectedPackageLength = 1
        this.form.price.discount.type = 'no'
        this.patientId = val.patientId
        this.locations = []
        if (val.hospital) {
          this.locations.push('hospital')
          setTimeout(() => {
            this.form.hospital = val.hospital
            this.getRawHospital()
          }, 300)
        }
        if (val.address) {
          this.locations.push('home')
          setTimeout(() => {
            this.form.address = val.address
            this.getDistricts()
            this.getSubdistricts()
          }, 300)
        }
        setTimeout(() => {
          this.getPrice()
        }, 300)
      }
    },
  },
  props: {
    reservation: {
      type: Object,
    },
    type: {
      type: String,
      required: true,
    },
    line: {
      type: String,
      required: true,
    },
  },
  computed: {
    isHaveNormalDiscount () {
      return this.form.price.discount.type === 'fixed' || this.form.price.discount.type === 'percent'
    },
    calculator () {
      return this.priceCalculator
    },
    isDisabledSave () {
      let completeSelectDate = this.pck === 'dialy' ? this.form.dates.length === this.selectedPackageLength : true
      let completePrice = true
      if (this.type === 'edit') {
        completePrice = this.form.price.base !== '' && this.form.price.zone !== ''
        completeSelectDate = this.form.dates.length === this.selectedPackageLength
      }
      if (this.pck !== 'daily') {
        completeSelectDate = true
      }
      let isSelectedHome = (this.locations.indexOf('home') >= 0) && !(!!this.form.address.address && !!this.form.address.district && !!this.form.address.province && !!this.form.address.subdistrict)
      let isSelectedHospital = (this.locations.indexOf('hospital') >= 0) && !(!!this.form.hospital.name && !!this.form.hospital.province && !!this.form.hospital.room !== '')
      let isCare = (this.locations.indexOf('hospital') >= 0) && (this.locations.indexOf('home') < 0) && this.form.hospital.care === null
      let isPromocodeEmpty = this.form.price.discount.type === 'code' && this.form.promotionCode === ''
      return !(
        this.form.requireCaregiverTypes.length > 0 &&
        this.form.workType &&
        this.form.shift.type &&
        (
          (this.selectedPackage === 'daily' && this.form.dates.length === this.selectedPackageLength) ||
          ((this.selectedPackage === 'monthly' || this.selectedPackage === 'monthlyWithAddon') && this.form.dates.length > 0 && this.type === 'create') ||
          ((this.selectedPackage === 'monthly' || this.selectedPackage === 'monthlyWithAddon') && this.form.dates.length === this.selectedPackageLength && this.type === 'edit')
        ) &&
        this.locations.length > 0 &&
        this.form.price.discount.value < 100000 &&
        completeSelectDate &&
        completePrice &&
        !isSelectedHome &&
        !isSelectedHospital &&
        !isCare &&
        !isPromocodeEmpty
      )
    },
    lineIdCheck: function () {
      return this.line.length === 33 && this.line[0] === 'U'
    },
    showCalendar () {
      return this.form.shift.type !== '' && this.selectedPackage
    },
    maxDate () {
      if (this.type === 'create') {
        return Number(this.selectedPackageLength)
      }
      return this.dates.length
    },
    validateDiscount () {
      if (this.form.price.discount.type === 'percent') return this.form.price.discount.value > 0 && this.form.price.discount.value < 100
      else if (this.form.price.discount.type === 'fixed') return this.form.price.discount.value > 0 && this.form.price.discount.value < 100000
      else return true
    },
    pck () {
      if (this.type === 'create') {
        if (this.selectedPackage === 'daily') {
          return 'daily'
        } else if (this.selectedPackage === 'monthly') {
          return this.selectedAddonPackage === 'monthlyWithAddon' ? 'monthlyWithAddon' : 'monthly'
        } else return ''
      } else {
        return this.form.price.package
      }
    },
    calendarType () {
      return this.type === 'create' ? 'createReservation' : 'editReservation'
    },
    controlFakeDialog () {
      return this.showIsFakeDialog && this.type === 'create'
    },
  },
  methods: {
    async getRawHospital () {
      if (!this.form.hospital.province) return
      try {
        this.rawHospital = await this.$api.Resource.provincehospitals(this.form.hospital.province)
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    async getProvinces () {
      try {
        let res = await this.$api.Resource.provinces()
        this.provinces = [...res.result.provinces]
          .map((province) => ({
            value: province,
            label: province,
          }))
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    async getDistricts () {
      if (!this.form.address.province) return
      try {
        let res = await this.$api.Resource.districts(this.form.address.province)
        this.districts = [...res.result.districts]
          .map((province) => ({
            value: province,
            label: province,
          }))
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    async getSubdistricts () {
      if (!this.form.address.province || !this.form.address.district) return
      try {
        let res = await this.$api.Resource.subdistricts(this.form.address.province, this.form.address.district)
        this.subdistricts = [...res.result.subDistricts]
          .map((province) => ({
            value: province,
            label: province,
          }))
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    async getPromotions () {
      try {
        let raw = await this.$api.Reservation.promotions(this.patientId, this.selectedPackageLength, this.selectedPackage)
        this.codeList = raw.codes
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    async prepareCreateReservation () {
      try {
        const res = await this.$api.Reservation.preparecreate(this.patientId, this.form.service)

        this.selectedPackage = ''
        this.recommendedPackages = res.recommendedPackages
        this.selectedPackageLength = 1
        this.form.price.discount.type = 'no'
        this.patientId = res.patientId
        this.locations = []
        if (res.hospital) {
          this.locations.push('hospital')
          setTimeout(() => {
            this.form.hospital = res.hospital
            this.getRawHospital()
          }, 300)
        }
        if (res.address) {
          this.locations.push('home')
          setTimeout(() => {
            this.form.address = res.address
            this.getDistricts()
            this.getSubdistricts()
          }, 300)
        }

        if (this.form.service === 'escort') {
          this.form.workType = 'hr12'
          this.selectedPackage = 'daily'
          this.form.package = 'daily'
          this.selectedPackageLength = 1
          this.form.shift.type = 'day'
        }

        this.handleChangePackage(1)
        setTimeout(() => {
          this.getPrice()
        }, 300)
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    generateDailyPrice (daily) {
      let dailyPrice = []
      for (let i = 0; i < 30; i++) {
        dailyPrice.push((i + 1) * daily)
      }
      return dailyPrice
    },
    generateOverPriced (p) {
      for (let i = 0; i < 30; i++) {
        if (p.daily[i] > p.monthly) return i + 1
      }
      return 0
    },
    async getPrice () {
      try {
        if (
            this.validateDiscount &&
            !(this.form.service === 'caregiver' && !(this.locations.length > 0 && (this.form.address.province.length || this.form.hospital.province.length))) &&
            this.type === 'create') {
          var discountPrice = {
            service: this.form.service,
            patientId: this.patientId,
            address: this.form.address,
            hospital: this.form.hospital,
            workType: this.form.workType,
            shifts: this.selectedPackageLength,
            discount: {
              type: this.form.price.discount.type,
              value: this.form.price.discount.value,
            },
            promotionCode: this.form.promotionCode,
            package: this.form.package,
          }
          if (discountPrice.discount.type === 'no' || discountPrice.discount.type === 'code') {
            discountPrice.discount = null
            discountPrice.promotionCode = this.form.promotionCode
          }
          if (!this.locations.includes('home')) {
            discountPrice.address = null
          }
          if (!this.locations.includes('hospital')) {
            discountPrice.hospital = null
          }
          if (!this.form.package) {
            delete discountPrice['package']
          }
          if (discountPrice.patientId !== 0) {
            this.panelPrice = await this.$api.Reservation.price(discountPrice)
            this.pricePlan = JSON.parse(JSON.stringify(this.panelPrice.pricePlan))
            this.pricePlan.daily = this.generateDailyPrice(this.panelPrice.pricePlan.daily)
            this.pricePlan.overPriced = this.generateOverPriced(this.pricePlan)
          }
        } else if (this.type === 'create') {
          this.panelPrice = {
            base: 0,
            meal: 0,
            beforeDiscount: 0,
            afterDiscount: 0,
            discount: 0,
            shifts: 0,
            shiftsTotal: 0,
            zone: 0,
            vat: 0,
            total: 0,
            net: 0,
            addon: 0,
            perDay: 0,
            pricePlan: {
              daily: 0,
              monthly: 0,
              monthlyPerDay: 0,
              monthlyWithAddonPerDay: 0,
            },
          }
          this.pricePlan.daily = []
          this.pricePlan.overPriced = 0
        }
        await this.updateStrategy()
      } catch (error) {}
    },
    async updateStrategy () {
      if (this.type === 'create' && this.patientId !== 0) {
        this.priceCalculator = new ReservationPricing(this.panelPrice)
      } else if (this.type === 'edit' && this.patientId !== 0) {
        try {
          let priceObject = {
            base: this.form.price.base ? this.form.price.base : 0,
            addon: this.form.price.addon ? this.form.price.addon : 0,
            discount: {
              type: this.form.price.discount.type,
              value: this.form.price.discount.value ? this.form.price.discount.value : 0,
            },
            patientId: this.patientId,
            promotionCode: this.form.promotionCode,
            shifts: this.form.dates.length,
            zone: this.form.price.zone ? this.form.price.zone : 0,
            package: this.form.price.package,
          }
          switch (priceObject.discount.type) {
            case 'code':
              if (this.edit.tempPromotionCode !== priceObject.promotionCode) {
                this.edit.tempPromotionCode = priceObject.promotionCode
                priceObject.discount = null
              } else {
                priceObject.promotionCode = null
                priceObject.discount.type = this.edit.discount.type
                priceObject.discount.value = this.edit.discount.value
              }
              break
            case 'no':
              priceObject.discount = {}
              priceObject.promotionCode = ''
              break
            default:
              priceObject.promotionCode = null
          }
          this.panelPrice = await this.$api.Reservation.calculate(priceObject)
          this.priceCalculator = new ReservationPricing(this.panelPrice)
          this.edit.discount.value = this.panelPrice.discount
        } catch (error) {
          this.showErrorDialog(error)
        }
      }
    },
    onSeleckPckType () {
      this.selectedPackageLength = 1
      this.handleChangePackage(this.selectedPackageLength)
    },
    showForm (inputLocation) {
      if (this.locations) {
        return this.locations.find((location) => { return location === inputLocation }) === inputLocation
      }
      return false
    },
    changeProvince () {
      this.getDistricts()
      this.form.address.district = ''
      this.form.address.subdistrict = ''
      this.getPrice()
    },
    changeProvinceHospital () {
      this.form.hospital.name = ''
      this.results = ''
      this.timeout = null
      this.getRawHospital()
      this.getPrice()
    },
    changeDistrict () {
      this.getSubdistricts()
      this.form.address.subdistrict = ''
    },
    queryHospital (queryString, cb) {
      const hospitals = this.rawHospital.result.hospitals.map((hospital) => ({ value: hospital }))
      const queries = queryString ? hospitals.filter((hospital) => {
        const queryRegex = new RegExp(`${queryString}`)
        return hospital.value.match(queryRegex)
      }) : [{ value: 'โปรดกรอกข้อมูล' }]
      this.results = queries.length === 0 ? [{ value: 'ไม่พบข้อมูล' }] : queries
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        cb(this.results)
      }, 1000 * Math.random())
    },
    handleAutocompleteHospital (item) {
      if (item.value === 'ไม่พบข้อมูล' || item.value === 'โปรดกรอกข้อมูล') {
        this.form.hospital.name = ''
      }
    },
    async forceUpdateCalendar (dates) {
      await this.$refs.calendar.foceUpdateData(dates)
      await this.backgroundColorHandler()
    },
    async changePromo () {
      this.edit.showDialog = true
      await this.getPromotions()
      this.edit.modalPromotionCode = this.form.promotionCode
      if (this.codeList.indexOf(this.edit.modalPromotionCode) < 0) this.edit.modalPromotionCode = ''
    },
    handleClose () {
      this.edit.showDialog = false
    },
    handleUpdate () {
      this.form.promotionCode = this.edit.modalPromotionCode
      this.handleClose()
      this.getPrice()
    },
    handleChangeWorkType () {
      this.getPrice()
      if (this.form.workType === 'hr24') {
        this.form.shift.type = 'day'
        this.handleChangeShift()
      }
    },
    handleChangeShift () {
      this.day.start = this.night.end = '07:00'
      this.day.end = this.night.start = '19:00'
      this.form.shift.start = this.form.shift.type === 'day' ? this.day.start : this.night.start
      this.form.shift.end = this.form.shift.type === 'day' ? this.day.end : this.night.end
      this.clearDates()
    },
    handleChangePackage (shifts) {
      this.clearDates()
      if (this.form.price.discount.type === 'code') {
        this.form.promotionCode = ''
        this.getPromotions()
      }
      this.selectedPackageLength = shifts
      if (this.selectedPackage === 'monthly' && this.selectedAddonPackage === 'monthlyWithAddon') {
        this.form.package = this.selectedAddonPackage
      } else {
        this.selectedAddonPackage = 'none'
        this.form.package = this.selectedPackage
      }
      if (this.form.package === 'monthly') {
        this.selectedPackageLength = 31
        this.selectedAddonPackage = 'none'
      }
      this.getPrice()
      if ((this.type === 'edit' && this.form.price.package === 'monthly') || (this.type === 'create' && this.selectedPackage === 'monthly' && this.selectedAddonPackage === 'none')) {
        if (this.dayOff === '') {
          this.dayOff = 'Sunday'
        }
        this.form.daysOff = [this.dayOff]
      } else {
        this.dayOff = ''
        this.form.daysOff = []
      }
    },
    clearDates () {
      this.form.dates = []
      this.forceUpdateCalendar(this.form.dates)
    },
    clearDiscount () {
      this.form.price.discount.value = 0
      this.getPromotions()
      if (this.type === 'create') this.form.promotionCode = ''
      this.getPrice()
    },
    onDaysOffChange () {
      this.form.daysOff = [this.dayOff]
      this.clearDates()
    },
    goPreviousMonth () {
      this.$refs.calendar.previousMonth()
      this.backgroundColorHandler()
    },
    goNextMonth () {
      this.$refs.calendar.nextMonth()
      this.backgroundColorHandler()
    },
    deleteButtonClick () {
      this.$emit('delete', { id: this.form.id, patientId: this.patientId })
      let el = document.querySelector(':focus')
      if (el) el.blur()
    },
    clickCancel () {
      this.$emit('cancel')
    },
    async confirmUpdateStartDateVaildate () {
      if (this.type === 'edit') {
        try {
          let res = await this.$api.Reservation.validateupdate(this.form.id, this.form.dates)
          if (!res.validate) {
            this.showUpdateStartDateReservationToTodayConfirmationDialog = true
          } else {
            this.clickSave()
          }
        } catch (error) {
          this.showErrorDialog(error)
        }
      } else {
        this.clickSave()
      }
    },
    clickSave () {
      this.showUpdateStartDateReservationToTodayConfirmationDialog = false
      if (!this.locations.includes('hospital')) this.form.hospital = null
      if (!this.locations.includes('home')) this.form.address = null
      if (this.type === 'edit') this.reformForUpdate()
      this.$emit('save', { reservation: this.form })
    },
    reformForUpdate () {
      switch (this.form.price.discount.type) {
        case 'code':
          if (this.edit.beforePromotionCode === this.form.promotionCode) {
            this.form.price.discount = this.edit.discount
            this.form.promotionCode = null
          } else if (this.edit.beforePromotionCode !== this.form.promotionCode) {
            this.form.price.discount = {}
          } else if (this.edit.tempPromotionCode !== this.form.promotionCode) {
            this.edit.tempPromotionCode = this.form.promotionCode
            this.form.price.discount = null
          } else {
            this.form.promotionCode = null
            this.form.price.discount.type = this.edit.discount.type
            this.form.price.discount.value = this.edit.discount.value
          }
          break
        case 'no':
          this.form.price.discount = {}
          this.form.promotionCode = ''
          break
        case 'fixed':
        case 'percent':
          this.form.promotionCode = ''
          break
        default:
          this.form.promotionCode = null
      }
    },
    backgroundColorHandler () {
      document.querySelectorAll('[id^="calendarReservEdit"] .fc-day').forEach((day) => { day.style.backgroundColor = '#fff' })
      document.querySelectorAll('.fc-today').forEach((day) => { day.style.backgroundColor = '#e7f5ff' })
    },
    numberFormat (value) {
      return Number(value).toLocaleString()
    },
    closeFakeDialog () {
      this.showIsFakeDialog = false
    },
  },
  filters: {
    numberFormat (value) {
      return Number(value).toLocaleString()
    },
    numberFormatTwoDigit (value) {
      return Number(value).toLocaleString(undefined, { minimumFractionDigits: 2 })
    },
  },
}
</script>
